import { useState, useEffect } from 'react';

/**
 * Custom hook to detect scroll direction and control header visibility
 * Shows header when scrolling up, hides when scrolling down past threshold
 *
 * @param {number} threshold - Minimum scroll position to trigger auto-hide (default: 50px)
 * @returns {boolean} showHeader - Whether the header should be visible
 *
 * @example
 * const showHeader = useScrollDirection(50);
 * <div className={showHeader ? 'translate-y-0' : '-translate-y-full'}>
 */
export function useScrollDirection(threshold = 50) {
  const [showHeader, setShowHeader] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY && currentScrollY > threshold) {
        // Scrolling down & past threshold
        setShowHeader(false);
      } else {
        // Scrolling up
        setShowHeader(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY, threshold]);

  return showHeader;
}
